import { ArrowRightYellowIcon } from "assets/svg";
import React from "react";
import { toVND, toUTop, priceRangeV3 } from "utils/currencyFormat";
import DEFAULT_FEED_IMAGE from "assets/img/feed-img-default--border-radius-0.jpg";
import "./DealSection.scss";
import Skeleton from "react-loading-skeleton";
import { VOUCHER_TYPES, CURRENCY_TYPE } from "constants/types";

const DealItemSkeleton = () => {
  return (
    <div className="deal-item">
      <Skeleton className="deal-item__img" />
      <div className="deal-item__content">
        <div className="only-2-lines deal-item__name">
          <Skeleton width="100%" style={{ maxWidth: "60ch" }} />
        </div>

        <div className="text-on-1-line deal-item__desc">
          <Skeleton width="70%" style={{ maxWidth: "40ch" }} />
        </div>

        <div className="deal-item__price-container">
          <span className="deal-item__price--current">
            <Skeleton width="6ch" />
          </span>
          <span className="deal-item__price--old">
            <Skeleton width="7ch" />
          </span>
        </div>
      </div>
    </div>
  );
};

export const DealSectionSkeleton = () => {
  return (
    <div className="deal-section-wrapper">
      <div className="deal-section__top">
        <h3 className="deal-section__top__title">
          <Skeleton width="12ch" />
        </h3>
      </div>

      <div className="deal-section__list">
        <DealItemSkeleton />
        <DealItemSkeleton />
        <DealItemSkeleton />
      </div>
    </div>
  );
};

const DealItem = (props) => {
  const {
    images = [],
    name = "",
    shortDescription = "",
    prices,
    type,
    currencies,
    exchangeRate,
    handleDirectToVoucherViewPage,
  } = props;

  const imgUrl =
    images.find((image) => image.isFeatured === true)?.imageUrl ||
    images?.[0]?.imageUrl;
  // const priceToShow = prices.find((price) => price.default === true);

  return (
    <div className="deal-item" onClick={handleDirectToVoucherViewPage}>
      <div className="deal-image">
        <object
          type="image/png"
          data={imgUrl || DEFAULT_FEED_IMAGE}
          className="deal-item__img"
        >
          <img src={DEFAULT_FEED_IMAGE} className="deal-item__img" />
        </object>
        {type !== VOUCHER_TYPES.GEN_VOUCHER_WITH_AMOUNT &&
          prices &&
          prices.length > 0 &&
          priceRangeV3(prices, "percent") > 0 && (
            <div className="deal-card-percent">
              -{priceRangeV3(prices, "percent")}%
            </div>
          )}
      </div>

      <div className="deal-item__content">
        {name && <div className="only-2-lines deal-item__name">{name}</div>}
        {shortDescription && (
          <div className="text-on-1-line deal-item__desc">
            {shortDescription}
          </div>
        )}

        {type !== VOUCHER_TYPES.GEN_VOUCHER_WITH_AMOUNT &&
          prices &&
          prices.length > 0 && (
            <div
              className="deal-item__price-container text-1-line"
              style={{
                display: "flex",
                flexDirection: priceRangeV3(prices)?.list?.maxValue
                  ? "column"
                  : "row",
              }}
            >
              <div style={{ marginRight: "6px" }}>
                <span className="deal-item__price--current">
                  {currencies?.toLowerCase() === CURRENCY_TYPE.UTOP.name
                    ? `${toUTop(
                        priceRangeV3(prices).selling?.minValue,
                        exchangeRate
                      )}`
                    : `${toVND(priceRangeV3(prices).selling?.minValue)}`}
                </span>
                {priceRangeV3(prices).selling?.maxValue && (
                  <span className="dash-price"> - </span>
                )}
                {priceRangeV3(prices).selling?.maxValue && (
                  <span className="deal-item__price--current">
                    {currencies?.toLowerCase() === CURRENCY_TYPE.UTOP.name
                      ? toUTop(
                          priceRangeV3(prices).selling?.maxValue,
                          exchangeRate
                        )
                      : toVND(priceRangeV3(prices).selling?.maxValue)}
                  </span>
                )}
              </div>
              {priceRangeV3(prices)?.list?.minValue && (
                <div>
                  <span className="deal-item__price--old strike-low">
                    {currencies?.toLowerCase() === CURRENCY_TYPE.UTOP.name
                      ? `${toUTop(
                          priceRangeV3(prices).list?.minValue,
                          exchangeRate
                        )}`
                      : `${toVND(priceRangeV3(prices).list?.minValue)}`}
                  </span>
                  {priceRangeV3(prices).list?.maxValue && (
                    <span
                      className="deal-item__price--old strike-low"
                      style={{ marginLeft: "25px" }}
                    >
                      {currencies?.toLowerCase() === CURRENCY_TYPE.UTOP.name
                        ? toUTop(
                            priceRangeV3(prices).list?.maxValue,
                            exchangeRate
                          )
                        : toVND(priceRangeV3(prices).list?.maxValue)}
                    </span>
                  )}
                </div>
              )}
            </div>
          )}
      </div>
    </div>
  );
};

const NUMBER_OF_ITEMS_TO_SHOW = 6;

const DealSection = (props) => {
  const {
    idPivot,
    isLoading = true,
    listDeal = [],
    handleDirectToListDealPage,
    handleDirectToVoucherViewPage,
  } = props;

  if (isLoading) return <DealSectionSkeleton />;
  if (!listDeal?.length > 0) return <></>;

  return (
    <div id={idPivot} className="deal-section-wrapper">
      <div className="deal-section__top">
        <h3 className="deal-section__top__title">Deal/Voucher</h3>
        {listDeal.length > NUMBER_OF_ITEMS_TO_SHOW && (
          <button
            type="button"
            className="deal-section__top__btn-see-more"
            onClick={handleDirectToListDealPage}
          >
            <span>Xem thêm</span>
            <i>
              <ArrowRightYellowIcon />
            </i>
          </button>
        )}
      </div>

      <div className="deal-section__list">
        {listDeal.slice(0, NUMBER_OF_ITEMS_TO_SHOW).map((deal) => (
          <DealItem
            key={deal.id}
            images={deal?.images}
            name={deal.title?.vi}
            shortDescription={deal.description?.vi}
            // prices={getDefaultPrice(deal?.prices)}
            prices={deal?.prices}
            type={deal.type?.[0]}
            handleDirectToVoucherViewPage={handleDirectToVoucherViewPage({
              idVoucher: deal.id,
            })}
            currencies={deal.currencies[0]?.name}
            exchangeRate={deal.currencies[0]?.exchangeRate}
            currenciesInfo={deal.currencies}
          />
        ))}
      </div>
    </div>
  );
};

export default React.memo(DealSection);
